/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NaturalPersonLinkSolicitationAliases {
  ACCEPT_BUTTON = 'accept-button',
  BUTTON_PANEL = 'button-panel',
  DENY_BUTTON = 'deny-button',
  LOGIN_BUTTON = 'login-button',
  LOGO_IMAGE = 'logo-image',
  MESSAGE_PANEL = 'message-panel',
  SOLICITATION_LAYOUT = 'solicitation-layout',
  SOLICITATION_TEXT = 'solicitation-text',
  SUCCESSFUL_PANEL = 'successful-panel',
  TITLE_IMAGE = 'title-image',
  TITLE_PANEL = 'title-panel',
}
export { NaturalPersonLinkSolicitationAliases };
